const moment = require('moment');

export function sortWorkLogsByDate(workLogs) {
  workLogs.sort((a, b) => moment(a.date).diff(moment(b.date)));
}

export function sortTeamMembersAlphabetically(teamMembers) {
  teamMembers.sort((a, b) =>
    (a.name || a.email).localeCompare(b.name || b.email),
  );
}



// WEBPACK FOOTER //
// ./src/helpers/sort.js